import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import clsx from "clsx";

import { reducerSidebar } from "../../redux/reducer/user/reducers/reducerUser";

import { reducerVacancyClearInputValues } from "../../redux/reducer/recruiting/reducers/reducerVacancy";
import { reducerProjectClearValues } from "../../redux/reducer/projects/reducers/reducerProjectsList";
import { reducerRoutesClearInputValues } from "../../redux/reducer/projects/reducers/reducerRoutesList";
import { reducerRoutesNoModalClearInputValues } from "../../redux/reducer/projects/reducers/reducerRoutesListNoModal";
import { reducerVacantRouteslClearInputValues } from "../../redux/reducer/projects/reducers/reducerVacantRoutesList";
import { reducerUsersClearInputValues } from "../../redux/reducer/easymerch/reducers/reducerUsers";
import { reducerReportsClearInputValues } from "../../redux/reducer/easymerch/reducers/reducerReports";
import { reducerOutletsClearInputValues } from "../../redux/reducer/easymerch/reducers/reducerOutlets";
import { reducerIntegrationErrorsClearInputValues } from "../../redux/reducer/easymerch/reducers/reducerIntegrationErrors";
import { reducerZipUnloadingsClearInputValues } from "../../redux/reducer/unloadings/reducers/zipUnloadings";
import { reducerTemplateClearInputValues } from "../../redux/reducer/unloadings/reducers/templateUnloadings";
import { reducerTablesUnloadingsClearInputValues } from "../../redux/reducer/unloadings/reducers/tablesUnloadinds";
import { reducerExcelUnloadingsClearInputValues } from "../../redux/reducer/unloadings/reducers/excelUnloadings";
import { reducerCronUnloadingsClearInputValues } from "../../redux/reducer/unloadings/reducers/cronUnloadings";
import { reducerCustomerClearInputValues } from "../../redux/reducer/accessRights/reducers/customersList";
import { reducerExpiredReportsClearInputValues } from "../../redux/reducer/userReports/reducers/expiredReports";
import { reducerUserReportsClearInputValues } from "../../redux/reducer/userReports/reducers/userReports";
import { recuceClearChartsInputValues } from "../../redux/reducer/charts/reducer/reducerCharts";
import { reducerClearFilters } from "../../redux/reducer/accessRights/reducers/usersList";
import { recuceClearMapInputValues } from "../../redux/reducer/map/reducer/reducerMapsList";
import { reducerRolesClear } from "../../redux/reducer/accessRights/reducers/roles";
import { reducerServiceTypesClear } from "../../redux/reducer/easymerch/reducers/reducerServiceTypes";
import { reducerClearInputValuesCreateVacancy } from "../../redux/reducer/recruiting/reducers/reducerCreateVacancy";
import { reducerClearInputValuesSingleVacancy } from "../../redux/reducer/recruiting/reducers/reducerSingleVacancy";

import { AppDispatch } from "../../redux/reducer/store";

import CustomerSidebarSection from "./sections/customerSidebarSection";
import AdminSidebarSection from "./sections/adminSidebarSection";

import { ReactComponent as ChevronIcon } from "../../assets/icons/chevron.svg";
import { ReactComponent as ExcludeIcon } from "../../assets/icons/exclude.svg";
import { ReactComponent as AvatarIcon } from "../../assets/icons/avatar.svg";
import { ReactComponent as ExitIcon } from "../../assets/icons/exit.svg";

import "./sidebar.scss";
import ThemeSwitcher from "../themeSwitcher/themeSwitcher";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const Sidebar: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { data, isOpenSidebar, isOpenUnloadings } = useSelector(
    (state: any) => state.user.user
  );

  const userData = JSON.parse(localStorage.getItem("userData") as string);
  const { darkTheme } = useSelector((state: any) => state.theme.theme);

  const clearFilters = () => {
    dispatch(reducerRolesClear());
    dispatch(reducerClearFilters());
    dispatch(reducerServiceTypesClear());
    dispatch(reducerProjectClearValues());
    dispatch(recuceClearMapInputValues());
    dispatch(recuceClearChartsInputValues());
    dispatch(reducerUsersClearInputValues());
    dispatch(reducerRoutesClearInputValues());
    dispatch(reducerVacancyClearInputValues());
    dispatch(reducerOutletsClearInputValues());
    dispatch(reducerReportsClearInputValues());
    dispatch(reducerCustomerClearInputValues());
    dispatch(reducerTemplateClearInputValues());
    dispatch(reducerUserReportsClearInputValues());
    dispatch(reducerZipUnloadingsClearInputValues());
    dispatch(reducerVacantRouteslClearInputValues());
    dispatch(reducerRoutesNoModalClearInputValues());
    dispatch(reducerClearInputValuesCreateVacancy());
    dispatch(reducerClearInputValuesSingleVacancy());
    dispatch(reducerExpiredReportsClearInputValues());
    dispatch(reducerCronUnloadingsClearInputValues());
    dispatch(reducerExcelUnloadingsClearInputValues());
    dispatch(reducerTablesUnloadingsClearInputValues());
    dispatch(reducerIntegrationErrorsClearInputValues());
  };

  const handleClickExitBtn = () => {
    clearFilters();
    localStorage.removeItem("token");
    localStorage.removeItem("charts");
    localStorage.removeItem("userData");
    localStorage.removeItem("selectedChartsTabs");
    localStorage.removeItem("defaultDesktop");
    navigate("/login");
  };

  const handleOpenSidebar = () => {
    localStorage.setItem("isOpenSidebar", JSON.stringify(!isOpenSidebar));
    localStorage.setItem("isOpenUnloadings", JSON.stringify(false));

    dispatch(
      reducerSidebar({
        isOpenSidebar: !isOpenSidebar,
        isOpenUnloadings: false,
      })
    );
  };

  const handleLinkClick = (event: React.MouseEvent) => {
    if (!data.claims || !data.claims.includes("admin")) {
      event.preventDefault();
    }
  };

  return (
    <>
      {JSON.parse(IS_VISIBLE_SIDEBAR as string) && (
        <div className={clsx("leftMenu", !isOpenSidebar && "closed__leftMenu")}>
          <div
            className={clsx(
              "logo__block",
              !isOpenSidebar && "closed__logo_block"
            )}
          >
            <Link
              to="/reports"
              className={clsx("logo", !isOpenSidebar && "closed__logo")}
              onClick={handleLinkClick}
            >
              <div className="logo__img">
                <ExcludeIcon className="active__sidebar_icon" />
              </div>
              <div className="logo__text">Merch Online</div>
            </Link>
            <ChevronIcon
              onClick={handleOpenSidebar}
              className={clsx(
                "sidebar__chevron",
                isOpenSidebar && "active__sidebar_chevron",
                darkTheme?.isDarkTheme && "--dark"
              )}
            />
          </div>
          <div className={clsx("menu", !isOpenSidebar && "closed__menu")}>
            {!userData.isCustomer ? (
              <AdminSidebarSection
                isOpenUnloadings={isOpenUnloadings}
                isOpenSidebar={isOpenSidebar}
              />
            ) : (
              <CustomerSidebarSection
                isOpenUnloadings={isOpenUnloadings}
                isOpenSidebar={isOpenSidebar}
                data={data}
              />
            )}
          </div>
          {isOpenSidebar ? (
            <>
              <div className="menu__bottom__theme-switcher">
                <ThemeSwitcher />
              </div>
              <div className="menu__bottom">
                <div className="menu__bottom_avatar">
                  <AvatarIcon className="active__sidebar_icon" />
                </div>

                <div className="menu__bottom_text">
                  <span>{userData.login}</span>
                  <span>{Object.values(userData.role)}</span>
                </div>
              </div>
              <div className="exit__block">
                <span className="exit__btn" onClick={handleClickExitBtn}>
                  Выход
                </span>
              </div>
            </>
          ) : (
            <>
              <ThemeSwitcher isOpen={false} />
              <div className="menu__bottom_buttons">
                <div className="menu__bottom_btn" onClick={handleClickExitBtn}>
                  <ExitIcon className="exit__icon" />
                  <div className="tooltip">
                    <span className="tooltip__content">Выход</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Sidebar;
